import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Stack } from "@mui/material";
import CreateNewJobSidebarItems from "../../../Config/Export/CreateNewCustomer/CreateNewCustomersidebar";
import { useUser } from "@/Context/UserContext";
import { applyDynamicRules } from "@/Utils/Rules/ApplyConditions";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";

const SidebarMenu = ({ activeIndex, setActiveIndex, buttons = [] }) => {
  const { formData } = useUser();
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const items = CreateNewJobSidebarItems(formData);
    const updatedItems = applyDynamicRules(items, formData);
    setSidebarItems(updatedItems);

    const currentItem = updatedItems[activeIndex];
    if (currentItem?.disabled) {
      const firstEnabledIndex = updatedItems.findIndex((item) => !item.disabled);
      if (firstEnabledIndex !== -1) {
        setActiveIndex(firstEnabledIndex);
      }
    }
  }, [formData]);

  const handleTabChange = (e, newIndex) => {
    if (!sidebarItems[newIndex]?.disabled) {
      setActiveIndex(newIndex);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        borderBottom: 1,
        borderColor: "divider",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        bgcolor: "var(--gray-0)",
      }}
    >
      {/* ✅ TABS (SubTab Style) */}
      <Box sx={{ flexGrow: 1, overflowX: "auto" }}>
        <Tabs
          value={activeIndex}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "var(--green-100)",
              height: 3,
            },
            "& .MuiTab-root": {
              textTransform: "none",
              minWidth: "unset",
              padding: "6px 16px",
              color: "var(--gray-600)",
              fontWeight: 500,
              "&.Mui-selected": {
                color: "var(--brand-910)",
                fontWeight: 600,
              },
              "&:hover": {
                color: "var(--brand-910)",
              },
              "&.Mui-disabled": {
                opacity: 0.5,
                pointerEvents: "none",
              },
            },
          }}
        >
          {sidebarItems.map((item, index) => (
            <Tab
              key={`sidebar-tab-${index}`}
              label={item.label}
              disabled={item.disabled}
            />
          ))}
        </Tabs>
      </Box>

      {/* ✅ OPTIONAL BUTTONS ON RIGHT SIDE */}
      {buttons.length > 0 && (
        <Stack direction="row" spacing={1} sx={{ ml: 2 }}>
          {buttons.map((button, index) => (
            <OutLinedButton
              key={`sidebar-btn-${index}`}
              startAdornment={button.startAdornment}
              {...button}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default SidebarMenu;
